"use client";

import { useI18n } from "@/app/components/LanguageProvider";
import { useLocale } from "@/app/components/LocaleProvider";
import { getBaseLocale } from "@/lib/i18n";
import { cn } from "@/lib/utils";

export default function LangSwitcher() {
  const { toggle } = useI18n();
  const locale = useLocale();
  const isEnglish = getBaseLocale(locale) === "en";
  const langLabel = isEnglish ? "LANG" : "ЯЗЫК";

  return (
    <div className="group fixed bottom-6 right-[5vw] z-[90] hidden translate-x-1/2 md:block">
      <button
        type="button"
        aria-label={langLabel}
        title={langLabel}
        className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white/60 transition-all duration-200 hover:border-white/50 hover:bg-white/5 hover:text-white"
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src="/images/planet.svg"
          alt=""
          width={20}
          height={20}
          className="h-5 w-5 brightness-0 invert opacity-60"
        />
      </button>
      {/* The menu opens to the LEFT, not upward. Opening upward put it under
          the assistant button (fixed md:bottom-20, z-95), which has a higher
          z-index than this switcher (z-90): the pointer landed on the assistant
          button, the switcher lost :hover and the menu collapsed before RU/EN
          could be clicked. The strip to the left of the switcher is clear of
          the assistant button, its hint bubble and its panel. */}
      <div className="invisible absolute right-full top-1/2 mr-3 flex -translate-y-1/2 items-center gap-0.5 rounded-full border border-white/10 bg-[#202e64] p-1 opacity-0 shadow-lg transition-all duration-200 group-hover:visible group-hover:opacity-100">
        <button
          type="button"
          onClick={() => {
            if (locale !== "ru") toggle();
          }}
          className={cn(
            "rounded-full px-2.5 py-1 text-sm font-semibold transition-colors",
            locale === "ru"
              ? "text-[#2f73f2]"
              : "text-white/70 hover:text-white",
          )}
        >
          RU
        </button>
        <button
          type="button"
          onClick={() => {
            if (locale !== "en") toggle();
          }}
          className={cn(
            "rounded-full px-2.5 py-1 text-sm font-semibold transition-colors",
            locale === "en"
              ? "text-[#2f73f2]"
              : "text-white/70 hover:text-white",
          )}
        >
          EN
        </button>
      </div>
    </div>
  );
}